import { default as AbstractModal } from './AbstractModal'

export default class ModalVideo extends AbstractModal {

    constructor(m) {
        super(m)

        // DOM
        this.$el = this.el
        this.$video = this.$('video')[0]

        // Events
        this.events = {
            click: {
                'close': 'close',
            },
        }

    }

    onOpen(e) {

        if(this.emptyTimeout) {
            clearTimeout(this.emptyTimeout);
        }

        this.appendDelay = setTimeout(() => {
            switch (e.host) {
                case 'youtube':
                    this.$video.innerHTML = `<iframe src="https://www.youtube.com/embed/${e.id}?&autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`
                    break;
                case 'vimeo':
                    this.$video.innerHTML = `<iframe src="https://player.vimeo.com/video/${e.id}?autoplay=1&loop=1&autopause=0" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`
                    break;
                case 'mp4':
                    this.$video.innerHTML = `<video src="${e.id}" autoplay controls></video>`
                    break;
                default:
                    break;
            }
        }, 300)

    }

    onClose() {
        clearTimeout(this.appendDelay)
        // this.emptyTimeout = setTimeout(() => {
            this.$video.innerHTML='';
        // }, 250);
    }
}
